<template>
  <div class="card" v-if="carregando">
    <div class="card-body">
      <div class="text-center">
        <b-spinner class="ms-2" variant="primary"></b-spinner>
      </div>
    </div>
  </div>

  <div class="card" v-else>
    <div class="card-body table-responsive">
      <b-table
        bordered
        show-empty
        :hover="hover"
        :small="small"
        :items="dados"
        responsive="sm"
        :striped="striped"
        class="datatables"
        :foot-clone="footClone"
        :per-page="itensPorPagina"
        :current-page="currentPage"
        :tbody-tr-class="getRowClass"
        :details-td-class="getCellClass"
        :fields="normalizeFields(colunas)"
      >
        <!-- Células customizadas -->
        <template
          v-for="celula in celulasCustomizadas"
          v-slot:[`cell(${celula.key})`]="data"
        >
          <slot :name="`cell(${celula.key})`" v-bind="data" />
        </template>

        <!-- Footer customizado -->
        <template
          v-for="celulaFooter in celulasCustoizadasFooter"
          v-slot:[`foot(${celulaFooter.key})`]="data"
        >
          <slot :name="`foot(${celulaFooter.key})`" v-bind="data" />
        </template>

        <!-- Primeira coluna com ícone -->
        <template v-slot:cell(sequencia)="data">
          <span v-if="getRowIcon(data.item)">
            <i :class="getRowIcon(data.item)" style="margin-right: 5px"></i>
          </span>
          {{ data.value }}
        </template>

        <template #empty>
          <div class="text-center text-muted">{{ mensagemPadrao }}</div>
        </template>
      </b-table>

      <b-pagination
        align="right"
        v-if="paginacaoAtiva"
        v-model="currentPage"
        :total-rows="dados.length"
        :per-page="itensPorPagina"
        class="pagination pagination-rounded mb-0"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    colunas: { type: Array, required: true },
    dados: { type: Array, required: true },
    carregando: { type: Boolean, default: false },
    footClone: { type: Boolean, default: false },
    itensPorPagina: { type: Number, default: 10 },
    paginacaoAtiva: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    mensagemPadrao: { type: String, default: "Nenhum dado encontrado." },
  },
  data() {
    return { currentPage: 1 };
  },
  computed: {
    celulasCustomizadas() {
      return this.colunas.filter((field) => this.$scopedSlots[`cell(${field.key})`]);
    },
    celulasCustoizadasFooter() {
      return this.colunas.filter((field) => this.$scopedSlots[`foot(${field.key})`]);
    },
  },
  methods: {
    normalizeFields(colunas) {
      return colunas.map((col) => ({
        key: col.key,
        label: col.label,
        sortable: !!col.sortable,
        class: col.sortable ? "sortable" : "not-sortable",
      }));
    },
    getRowClass(item, type) {
      if (!item || type !== "row") return "";
      for (const col of this.colunas) {
        if (!col.settingsLine) continue;
        const cfg = col.settingsLine;

        if (cfg.condicao && cfg.condicao(item)) {
          if (cfg.corLinha) {
            const className = `dynamic-bg-${cfg.corLinha.replace("#", "")}`;
            if (!document.getElementById(className)) {
              const style = document.createElement("style");
              style.id = className;
              style.innerHTML = `
                .${className} {
                  background-color: ${cfg.corLinha} !important;
                  color: ${cfg.textColor || "inherit"} !important;
                }
              `;
              document.head.appendChild(style);
            }
            return className;
          }
          if (cfg.classe) return cfg.classe;
          return "";
        }
      }
      return "";
    },
    getRowIcon(item) {
      for (const col of this.colunas) {
        if (!col.settingsLine) continue;
        const cfg = col.settingsLine;
        if (cfg.condicao && cfg.condicao(item) && cfg.icon) return cfg.icon;
      }
      return null;
    },
    getCellClass(item, colIndex) {
      for (const col of this.colunas) {
        if (!col.settingsLine) continue;
        const cfg = col.settingsLine;
        if (cfg.condicao(item) && cfg.idxCelula === colIndex) {
          return cfg.classeCelula || "";
        }
      }
      return "";
    },

    getCellStyle(item, colIndex) {
      for (const col of this.colunas) {
        if (!col.settingsLine) continue;
        const cfg = col.settingsLine;

        if (cfg.condicao(item) && cfg.idxCelula === colIndex) {
          return {
            backgroundColor: cfg.corLinha || "",
            color: cfg.textColor || "",
          };
        }
      }
      return {};
    },
  },
};
</script>

<style>
.sortable-header {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.sort-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5px;
}

.datatables thead tr th.not-sortable:before,
.datatables thead tr th.not-sortable::after {
  content: none !important;
}
</style>
